import Component from '../core/Component'
import scrollToElement from '../services/Viewport/scrollToElement'

export default class Page extends Component {

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        //+GTM
        let target = event.target.closest('[data-gtm-event]')
        if (target && window.dataLayer) {
            try {
                window.dataLayer.push(JSON.parse(target.dataset.gtmEvent))
            } catch (e) {
                console.warn('dataLayer', e)
            }
        }



        if (event.defaultPrevented) {
            return
        }

        target = event.target.closest('a')

        if (!target) {
            return
        }

        if (document.location.href.split('#')[0] !== target.href.split('#')[0]) {
            return
        }

        const id = target.href.split('#')[1]

        if (!id) {
            return
        }

        const element = document.getElementById(id)

        if (!element) {
            return
        }

        event.preventDefault()

        let offset = (target.dataset.offset) ? target.dataset.offset : 0
        let mode = (target.dataset.mode) ? target.dataset.mode : 'force-center'
        scrollToElement(element, { offset, mode })
    }
}